import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso5pagePage } from './paso5page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso5pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso5pagePageRoutingModule {}
